import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

/* Final CTA — restrained deep-green framed banner (not a full-width rectangle). */

const FinalCtaSection = ({ loggedIn }) => (
  <section
    data-testid="final-cta-section"
    className="px-4 pb-24 pt-4 sm:px-8 lg:px-12"
  >
    <Reveal className="mx-auto max-w-5xl">
      <div className="relative overflow-hidden rounded-[2rem] bg-[#14532D] px-6 py-16 text-center sm:px-12 md:py-20">
        {/* subtle light accents */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#FACC15]/15 blur-3xl"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-[#22C55E]/20 blur-3xl"
        />
        <h2
          data-testid="final-cta-headline"
          className="relative mx-auto max-w-2xl font-display text-[38px] font-bold leading-[1.12] tracking-tight text-[#F8FAF7] sm:text-[50px] lg:text-[60px]"
        >
          Ready to transform your exam preparation?
        </h2>
        <p className="relative mx-auto mt-4 max-w-xl font-body text-[18px] leading-[1.6] text-[#F8FAF7]/70 sm:text-[20px]">
          Start practicing today with curriculum-matched questions and instant
          AI guidance.
        </p>
        <Link
          to={loggedIn ? "/practice-setup" : "/signup"}
          data-testid="final-cta-button"
          data-magnetic="true"
          className="relative mt-8 inline-flex items-center gap-2 rounded-full bg-[#FACC15] px-8 py-4 text-[16px] font-extrabold text-[#14532D] shadow-lg transition-all duration-200 hover:bg-[#FEF9C3] sm:text-[17px]"
        >
          Start Practicing
          <ArrowRight className="h-5 w-5" />
        </Link>
      </div>
    </Reveal>
  </section>
);

export default FinalCtaSection;
